import {
    ClipboardList,
    Globe2,
    Server,
    Settings,
    Search,
    RadioTower,
    Share2,
    Box,
    Laptop,
    Zap,
    Camera,
    ShieldCheck,
    ShieldAlert,
    Activity,
    Bell,
    Package,
    BarChart3,
    FileText,
    Link2,
    User,
    Clock,
    Tag,
    Layers,
    BookOpen
} from 'lucide-react';
import React from 'react';

export interface NavItem {
    id: string;
    label: string;
    icon: React.ElementType;
    color: string;
}

export interface NavGroup {
    group: string;
    items: NavItem[];
}

export const navSections: NavGroup[] = [
    {
        group: 'Introduction',
        items: [
            { id: 'executive-summary', label: 'Executive Summary', icon: ClipboardList, color: 'text-blue-400' },
            { id: 'multi-tenant', label: 'Multi-Tenant Architecture', icon: Globe2, color: 'text-cyan-400' },
            { id: 'platform-architecture', label: 'Platform Architecture', icon: Server, color: 'text-purple-400' },
        ],
    },
    {
        group: 'Deployment',
        items: [
            { id: 'agent-gateway', label: 'Agent Gateway Deployment', icon: Settings, color: 'text-emerald-400' },
            { id: 'discovery-asset', label: 'Discovery & Assets', icon: Search, color: 'text-amber-400' },
            { id: 'snmp-overview', label: 'SNMP Monitoring', icon: RadioTower, color: 'text-orange-400' },
            { id: 'network-device', label: 'Network Device Monitoring', icon: RadioTower, color: 'text-orange-400' },
            { id: 'topology-viz', label: 'Topology Visualization', icon: Share2, color: 'text-indigo-400' },
        ],
    },
    {
        group: 'Infrastructure',
        items: [
            { id: 'digital-twin', label: 'Digital Twin', icon: Box, color: 'text-rose-400' },
            { id: 'endpoint-agents', label: 'Endpoint Agents', icon: Laptop, color: 'text-sky-400' },
            { id: 'oob-monitoring', label: 'Out-of-Band Monitoring', icon: Zap, color: 'text-yellow-400' },
            { id: 'camera-monitoring', label: 'Camera & Video', icon: Camera, color: 'text-red-400' },
            { id: 'kubernetes-monitoring', label: 'Kubernetes Dashboard', icon: Activity, color: 'text-cyan-400' },
        ],
    },
    {
        group: 'Security & Compliance',
        items: [
            { id: 'firewall-compliance', label: 'Firewall Compliance', icon: ShieldCheck, color: 'text-green-400' },
            { id: 'firewall-siem', label: 'Firewall SIEM', icon: ShieldAlert, color: 'text-rose-500' },
            { id: 'event-engine', label: 'Real-Time Event Engine', icon: Activity, color: 'text-violet-400' },
            { id: 'event-configuration', label: 'Event Configuration', icon: Activity, color: 'text-pink-500' },
            { id: 'notification-rules', label: 'Notification Rules', icon: Bell, color: 'text-amber-500' },
            { id: 'rule-engine', label: 'Advanced Rule Engine', icon: Settings, color: 'text-teal-400' },
        ],
    },
    {
        group: 'Management',
        items: [
            { id: 'patch-management', label: 'Patch Management', icon: Package, color: 'text-emerald-500' },
            { id: 'reporting-analytics', label: 'Reporting & Analytics', icon: BarChart3, color: 'text-blue-300' },
            { id: 'custom-dashboards', label: 'Custom Dashboards', icon: BarChart3, color: 'text-cyan-400' },
            { id: 'audit-logs', label: 'Audit Logs', icon: FileText, color: 'text-gray-400' },
            { id: 'integrations', label: 'Third-Party Integrations', icon: Link2, color: 'text-indigo-500' },
        ],
    },
    {
        group: 'Administration',
        items: [
            { id: 'user-management', label: 'User & RBAC', icon: User, color: 'text-blue-500' },
            { id: 'scheduler-jobs', label: 'Scheduler & Jobs', icon: Clock, color: 'text-teal-400' },
            { id: 'asset-tagging', label: 'Asset Tagging', icon: Tag, color: 'text-pink-400' },
            { id: 'osi-coverage', label: 'OSI Coverage', icon: Layers, color: 'text-purple-500' },
            { id: 'appendix', label: 'Appendix', icon: BookOpen, color: 'text-gray-300' },
        ],
    },
];
